/* -------------------------------------------------------------------------------- *\
|                               authHeader
\* -------------------------------------------------------------------------------- */
export function authHeader()
{
	const storedInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;

	if (storedInfo && storedInfo.username && storedInfo.accessToken)
	{
		return { 'x-access-token': storedInfo.accessToken };
	}
	else
	{
		return {};
	}
}
/* -------------------------------------------------------------------------------- *\
|                               hasAuth
\* -------------------------------------------------------------------------------- */
export function hasAuth(): boolean
{
	const storedInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;
	return storedInfo && storedInfo.username && storedInfo.accessToken && storedInfo.roles;
}
/* -------------------------------------------------------------------------------- *\
|                               hasAuth
\* -------------------------------------------------------------------------------- */
export function getUsername(): boolean
{
	const storedInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;
	return storedInfo && storedInfo.username && storedInfo.accessToken ? storedInfo.username : '';
}
/* -------------------------------------------------------------------------------- *\
|                               isAdmin
\* -------------------------------------------------------------------------------- */
export function isAdmin(): boolean
{
	const storedInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;
	return storedInfo && storedInfo.username && storedInfo.roles && storedInfo.roles.includes('admin');
}
/* -------------------------------------------------------------------------------- *\
|                               hasUSA
\* -------------------------------------------------------------------------------- */
export function hasUSA(): boolean
{
	const storedInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;
	return storedInfo && storedInfo.username && storedInfo.roles && (isAdmin() || storedInfo.roles.includes('USA'));
}
/* -------------------------------------------------------------------------------- *\
|                               hasFR
\* -------------------------------------------------------------------------------- */
export function hasFR(): boolean
{
	const storedInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;
	return storedInfo && storedInfo.username && storedInfo.roles && (isAdmin() || storedInfo.roles.includes('ICP'));
}
/* -------------------------------------------------------------------------------- *\
|                               hasQA
\* -------------------------------------------------------------------------------- */
export function hasQA(): boolean
{
	const storedInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;
	return storedInfo && storedInfo.username && storedInfo.roles && (isAdmin() || storedInfo.roles.includes('QA'));
}
/* -------------------------------------------------------------------------------- *\
|                               hasTracks
\* -------------------------------------------------------------------------------- */
export function hasTracks(): boolean
{
	const storedInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;
	return storedInfo && storedInfo.username && storedInfo.roles && (isAdmin() || storedInfo.roles.includes('tracks'));
}
/* -------------------------------------------------------------------------------- *\
|                               hasImu
\* -------------------------------------------------------------------------------- */
export function hasImu(): boolean
{
	const storedInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;
	return storedInfo && storedInfo.username && storedInfo.roles && (isAdmin() || storedInfo.roles.includes('imu'));
}
/* -------------------------------------------------------------------------------- *\
|                               hasOnlyImu
\* -------------------------------------------------------------------------------- */
export function hasOnlyImu(): boolean
{
	const storedInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;
	return storedInfo && storedInfo.username && storedInfo.roles && (storedInfo.roles.includes('imu') && !storedInfo.roles.includes('client') && !storedInfo.roles.includes('admin'));
}
/* -------------------------------------------------------------------------------- *\
|                               isViewer
|   read only: calendar / week / race, no edition (admin overrides)
\* -------------------------------------------------------------------------------- */
export function isViewer(): boolean
{
	const storedInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;
	return storedInfo && storedInfo.username && storedInfo.roles && (storedInfo.roles.includes('viewer') && !storedInfo.roles.includes('admin'));
}
/* -------------------------------------------------------------------------------- *\
|                               getToken
\* -------------------------------------------------------------------------------- */
export function getToken() : string
{
	const storedInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;

	if (storedInfo && storedInfo.username && storedInfo.accessToken)
	{
		return storedInfo.accessToken;
	}
	else
	{
		return '';
	}
}
